/**
 * Branch management enums
 * @see Issue #238 - Partner Companies B2B Model
 */

/**
 * Status of a business branch
 */
export enum BranchStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending', // Awaiting approval/setup
  SUSPENDED = 'suspended', // Temporarily disabled
}

/**
 * Branch status display names
 */
export const BRANCH_STATUS_NAMES: Record<BranchStatus, string> = {
  [BranchStatus.ACTIVE]: 'Active',
  [BranchStatus.INACTIVE]: 'Inactive',
  [BranchStatus.PENDING]: 'Pending',
  [BranchStatus.SUSPENDED]: 'Suspended',
};
